import { ReactElement, useId, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Dialog } from '@digdir/designsystemet-react';
import { MenuHeader } from './MenuHeader';
import { LogoHeader } from '../LogoHeader';
import { SidebarContent } from '../Sidebar';
import classes from './MobileMenu.module.css';

/**
 * Mobil: toppstripe med logo og «Meny». Menyen åpnes som en modal skuff fra venstre
 * (Designsystemet Dialog), med samme innhold som sidemenyen på desktop.
 * Den native dialogen gir fokusfelle, lukking med Escape og fokus tilbake til knappen.
 */
export const MobileMenu = (): ReactElement => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const dialogId = useId();
  const close = () => setIsOpen(false);

  return (
    <div className={classes.root} data-color="accent" data-print="false">
      <MenuHeader toggleMenu={() => setIsOpen((prev) => !prev)} isOpen={isOpen} panelId={dialogId} />
      <Dialog
        id={dialogId}
        open={isOpen}
        onClose={close}
        placement="left"
        closedby="any"
        closeButton={t('mobileMenu.closeMenu')}
        className={classes.drawer}
        aria-label={t('sidebar.navigationLabel')}
      >
        <div className={classes.drawerLogo}>
          <LogoHeader />
        </div>
        <SidebarContent onNavigate={close} />
      </Dialog>
    </div>
  );
};
